import { render } from "./LegacyStudentImportModal.vue?vue&type=template&id=03fb6e17&scoped=true"
import script from "./LegacyStudentImportModal.vue?vue&type=script&lang=js"
export * from "./LegacyStudentImportModal.vue?vue&type=script&lang=js"

import "./LegacyStudentImportModal.vue?vue&type=style&index=0&id=03fb6e17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fb6e17"]])

export default __exports__